import { connect } from 'react-redux';

import Footer from 'Component/Footer/Footer.component';
import {
    FooterContainer as SourceFooterContainer,
    mapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
} from 'SourceComponent/Footer/Footer.container';

/** @namespace Advox/Component/Footer/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    postcode: state.ConfigReducer.postcode,
    city: state.ConfigReducer.city,
    street_line1: state.ConfigReducer.street_line1,
    street_line2: state.ConfigReducer.street_line2,
    phone: state.ConfigReducer.phone,
    email: state.ConfigReducer.email,
});

/** @namespace Advox/Component/Footer/Container */
export class FooterContainer extends SourceFooterContainer {
    containerFunctions = {
        scrollTop: this.scrollTop.bind(this),
    };

    scrollTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    render() {
        return <Footer {...this.containerProps()} {...this.containerFunctions} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FooterContainer);
